import { jsx as _jsx } from "react/jsx-runtime";
import { createRef, useEffect, useRef } from "react";
import ChartJs from "chart.js/auto";
const init = (el, props) => {
    const canvas = el === null || el === void 0 ? void 0 : el.getContext("2d");
    if (canvas) {
        const chart = new ChartJs(canvas, {
            type: props.type,
            data: props.data,
            options: props.options,
        });
        // Attach ChartJs instance
        el.instance = chart;
    }
};
function Chart({ type = "line", data = {
    datasets: [],
}, options = {}, width = "auto", height = "auto", getRef = () => { }, className = "", ...computedProps }) {
    const props = {
        type: type,
        data: data,
        options: options,
        width: width,
        height: height,
        getRef: getRef,
        className: className,
    };
    const initialRender = useRef(true);
    const chartRef = createRef();
    useEffect(() => {
        if (initialRender.current) {
            props.getRef(chartRef.current);
            chartRef.current && init(chartRef.current, props);
            initialRender.current = false;
        }
        else {
            if (chartRef.current) {
                chartRef.current.instance.data = props.data;
                if (props.options) {
                    chartRef.current.instance.options = props.options;
                }
                chartRef.current.instance.update();
            }
        }
    }, [props.data, props.options]);
    return (_jsx("div", { style: {
            width: `${width}px`,
            height: `${height}px`,
        }, children: _jsx("canvas", { ...computedProps, className: props.className, ref: chartRef }) }));
}
export default Chart;